import { ThunkAction } from "redux-thunk";
import { ITaskUpdateRequest } from "../pages/Tasks/types";
import { RootState } from "../store";
import { AnyAction } from "redux";
import WorkTasksService from "../services/workTasks";
import {
  setErrorMessage,
  setSuccessMessage,
} from "./actionsCreators/messageActions";
import { UPDATE_RECORD_SUCCESS } from "../lib/constants";

export const assignTask =
  (
    id: string,
    req: ITaskUpdateRequest,
  ): ThunkAction<void, RootState, unknown, AnyAction> =>
  async (dispatch) => {
    try {
      const response = await WorkTasksService.update(id, req);

      dispatch(setSuccessMessage(UPDATE_RECORD_SUCCESS));

      return await Promise.resolve(response);
    } catch (error: any) {
      dispatch(setErrorMessage(error.response.data.title, true));
      return await Promise.reject(error);
    }
  };
